<template>
    <div class="match-progress">
        <div class="match-progress__">
            <Icon class="match-progress__icon" icon="match"/>
            <p class="match-progress__text">{{percent}}% Match</p>
        </div>
        <div class="match-progress__bar-container">
            <div :style="{width: `${percent}%`}" class="match-progress__bar"/>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/Theme/Icon'
export default {
    name: 'MatchProgress',
    components: {
        Icon
    },
    props: {
        percent: [Number, String]
    }
}
</script>

<style lang="scss" scoped>
$radius: 8px;
$font_size: 14px;
$color: #333333;
$progressbar_radius: 2px;
$progressbar_color: #FF2965;
$progressbar_bakcground: #E2E8F0;
$padding: 12px 12px 14px 12px;
$border: 1px solid $progressbar_bakcground;

.match-progress {
    border: $border;
    border-radius: $radius;
    padding: $padding;
    p {
        margin-bottom: 0;
    }
    &__ {
        display: flex;
        align-items: center;
    }
    &__icon {
        margin-right: 6px;
    }
    &__text {
        font-size: $font_size;
        color: $color;
        font-weight: bold;
    }
    &__bar-container {
        height: 6px;
        background: $progressbar_bakcground;
        border-radius: $progressbar_radius;
        position: relative;
        margin-top: 10px;
    }
    &__bar {
        position: absolute;
        height: 100%;
        left: 0;
        top: 0;
        background: $progressbar_color;
        border-radius: $progressbar_radius;
    }
}
</style>>
